import { COMMUNICATIONS_DETAIL_CONFIG } from "../components/CommunicationsDetailConfig";

// Actions and bulk actions configuration
export const communicationsActions = {
  view: true,
  edit: true,
  delete: true,
  create: true,
};

export const communicationsDetailActions = COMMUNICATIONS_DETAIL_CONFIG.actions;
